import 'slick-carousel';

export default function initGallery() {
  if ($('.gallery__item').length > 0) {
    $('.slider__main').each(function(key) {
      var sliderIdName = 'slider' + key;
      var sliderNavIdName = 'sliderNav' + key;

      this.id = sliderIdName;
      $('.slider__navigation')[key].id = sliderNavIdName;

      var sliderId = '#' + sliderIdName;
      var sliderNavId = '#' + sliderNavIdName;

      $(sliderId).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: sliderNavId,
      });

      $(sliderNavId).slick({
        slidesToShow: 4,
        centerPadding: '30px',
        slidesToScroll: 1,
        asNavFor: sliderId,
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
      });
    });

    $('.select-gallery').on('click', function () {
      if (!$(this).hasClass('menu__item--active')) {
        let target = `#${$(this).attr('data-target')}`
        $('.menu__item--active').removeClass('menu__item--active')
        $(target+'.select-gallery').addClass('menu__item--active')

        $('.gallery__item--active').fadeOut(400, function () {
          $(this).removeClass('gallery__item--active')
          $(target+'.gallery__item').fadeIn(400, function() {
            $(target+'.gallery__item').addClass('gallery__item--active')
          })
          $(target+'.gallery__item').find('.slider__main').slick('setPosition')
          $(target+'.gallery__item').find('.slider__navigation').slick('setPosition')
        })
      }
    })

    $('.popup-apartment__gallery').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/gallery.js